import { ActionIcon, Avatar, Box, Group, Menu, Text } from "@mantine/core";
import { IconBell, IconCoins, IconHelpCircle, IconLogout, IconPencil, IconSettings } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "@/context/UserContext";

export default function AppHeaderUserActions() {
  const navigate = useNavigate();
  const { userDetails, logout } = useUserContext();
  const userName = userDetails?.name?.trim() || "User";
  const companyName = userDetails?.company?.legalName || "Company Name";
  const gtid = userDetails?.company?.gtid || "User";

  return (
    <Box visibleFrom="sm">
      <Group gap="sm" wrap="nowrap" align="center">
        <ActionIcon size="lg" variant="light" radius="xl" aria-label="Notifications">
          <IconBell size={18} />
        </ActionIcon>
        <Menu shadow="md" width={230} position="bottom-end">
          <Menu.Target>
            <Avatar radius="xl" size="md" color="blue" style={{ cursor: "pointer" }}>
              {userName.charAt(0).toUpperCase()}
            </Avatar>
          </Menu.Target>
          <Menu.Dropdown>
            <Box px="sm" py={6}>
              <Group gap={8} wrap="nowrap">
                <Avatar radius="xl" size="sm" style={{ backgroundColor: "#eef2ff", color: "#1d4ed8" }}>
                  <IconSettings size={14} />
                </Avatar>
                <Box style={{ minWidth: 0 }}>
                  <Text size="sm" fw={600} truncate>
                    {companyName}
                  </Text>
                  <Text size="xs" c="dimmed" truncate>
                    {gtid}
                  </Text>
                </Box>
              </Group>
            </Box>
            <Menu.Divider />
            <Menu.Item leftSection={<IconPencil size={16} />} onClick={() => navigate("/profile/edit")}>
              Edit Profile
            </Menu.Item>
            <Menu.Item leftSection={<IconCoins size={16} />} onClick={() => navigate("/credits")}>
              Credits
            </Menu.Item>
            <Menu.Item leftSection={<IconHelpCircle size={16} />} onClick={() => navigate("/settings")}>
              Settings
            </Menu.Item>
            <Menu.Item color="red" leftSection={<IconLogout size={16} />} onClick={logout}>
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Box>
  );
}
